
export const API_URL = 'https://dev.ekhi.online/backend/';

export const API_PATH = {
    CONFIGURATIONS: API_URL + 'configurations',
    LOGS: API_URL + 'logs',
    SCHEDULES: API_URL + 'schedules',
    SCREENSHOTS: API_URL + 'screenshots',
    LOGIN: API_URL + 'login',
    USERS: API_URL + 'users',
    SET_ASSIGNABLE_SCENARIOS: API_URL + 'set-assignable-scenario',
    SESSIONS: API_URL + 'sessions',
} as const;